require('./scripts/ag.ui.wde.js');
require('./scripts/ag.ui.wde-moveable-chat.js');
require('./scripts/ag.ui.wde-resizeable-chat.js');